// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

// Internal Imports
import { DRAFT } from "../../constants";
import { checkAlignTypeBtnStatus } from "../../utils/draftUtils";

// Destructuring
const { TOOLBAR_ALIGN_BUTTONS } = DRAFT;

class AlignButtons extends Component {
  _onToggle = (event, type) => {
    event.preventDefault();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    this.props.handleAlignment(type);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    return TOOLBAR_ALIGN_BUTTONS.map(btn => {
      let className = `draftJsToolbar__button__qi1gf align-${btn.type}-button `;
      if (checkAlignTypeBtnStatus(this.props.editorState, btn.id)) {
        className += btn.activeClass;
      }
      return (
        <div
          className="draft-edit-items"
          id={btn.toolbarID}
          key={btn.toolbarID}>
          <div className="draftJsToolbar__buttonWrapper__1Dmqh">
            <Tooltip
              placement="top"
              overlay={btn.tooltip}
              align={{
                offset: [3, 0],
              }}>
              <button
                data-test={`revvtoolbar-alignbuttons-${btn.type}`}
                type="button"
                className={className}
                onMouseDown={event => this._onToggle(event, btn.type)}>
                <FontAwesomeIcon icon={["fas", `${btn.icon}`]} />
              </button>
            </Tooltip>
          </div>
        </div>
      );
    });
  }
}

export default AlignButtons;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/AlignButtons.js